module.exports = __webpack_public_path__ + "static/voc-4ba238f36b60c30b6d65eba87eb1d3b2.jpg";